module.exports = __webpack_public_path__ + "static/tabs-style-do-ae31dd31622be7d0ec50a1571942e837.png";